export default __webpack_public_path__ + "static/media/heads-04.3cb4a609.svg";